import { Component } from '@angular/core';

@Component({
  selector: 'app-who',
  templateUrl: './who.component.html',
  styleUrls: ['./who.component.scss'],
  standalone: false,
})
export class WhoComponent {}
